import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getLegalBanner } from "../../actions";
import isEmpty from "../../isEmpty";
import "react-multi-carousel/lib/styles.css";
import "../../index.css";

function LegalBanner(props) {
  const { legalBanner } = useSelector((state) => {
    return state.Legal;
  });

  const dispatch = useDispatch();

  const [heading, SetHeading] = useState("");
  const [backImage, SetBackImage] = useState("");

  useEffect(() => {
    dispatch(getLegalBanner());
  }, [dispatch]);

  useEffect(() => {
    if (!isEmpty(legalBanner)) {
      const items = legalBanner.items;
      console.log(items);
      if (!isEmpty(items)) {
        SetHeading(items[0].name_en);
        SetBackImage(items[1].image);
      }
    }
  }, [legalBanner]);

  const bannerstyle = { backgroundImage: "url(" + backImage + ")" };
  return (
    <section
      class="section_space banner_outer why_choose faq_banner"
      style={bannerstyle}
    >
      <div class="overlay"></div>
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-12">
            <div class="banner_inner">
              <div
                class="travel_title why_choose_title aos-item"
                data-aos="fade-up"
              >
                {heading}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export { LegalBanner };
